import { useContext } from "react";
import { Context } from "../../context/UserContext";
import styles from "./Input.module.css";

function Input({
    type = "text",
    text,
    name,
    placeholder,
    handleOnChange,
    handleOnBlur,
    handleOnFocus,
    value,
    title,
    required,
    multiple,
    inputWidth,
    readonly,
    disabled,
    min,
    max,
    textAlign = "right",
    handleOnInput,
    maxLength, // <- novo
    validateLatitude, // <- opcional: valida intervalo no onBlur
    hidden = false, // <- novo
}) {
    const { parametro } = useContext(Context);

    const sanitizeOnInput = (e) => {
        const v = e.target.value;
        // permite dígitos, ponto, vírgula e hífen (para negativos)
        e.target.value = v.replace(/[^0-9.,-]/g, "");
        if (handleOnInput) handleOnInput(e);
    };

    const onBlur = (e) => {
        // Normaliza vírgula para ponto (opcional)
        e.target.value = e.target.value.replace(",", ".");
        // Validação de latitude real (-90..90)
        if (validateLatitude) {
            const n = Number(e.target.value);
            if (!Number.isFinite(n) || n < -90 || n > 90) {
                e.target.setCustomValidity("Latitude deve estar entre -90 e 90.");
            } else {
                e.target.setCustomValidity("");
            }
        }
        handleOnBlur && handleOnBlur(e);
    };

    return (
        <div className={`${styles.form_control} ${styles[parametro.tema]}`}>
            <label htmlFor={name} title={title}>
                {hidden ? "" : `${text}:`}
            </label>
            <input
                type="text" // mantém text para maxLength funcionar
                name={name}
                id={name}
                placeholder={placeholder}
                onChange={handleOnChange}
                onBlur={onBlur}
                onFocus={handleOnFocus}
                value={value}
                title={title}
                required={required}
                style={{ width: `var(--input-width, ${inputWidth})`, textAlign }}
                multiple={multiple || undefined}
                readOnly={!!readonly}
                disabled={!!disabled}
                min={min}
                max={max}
                inputMode="decimal"
                maxLength={maxLength} // p.ex.: 10
                // Alinhe pattern com a sanitização OU remova-o
                pattern="^-?[0-9]+([.,][0-9]+)?$"
                onInput={sanitizeOnInput}
                autoComplete="off"
                spellCheck={false}
                hidden={hidden}
            />
        </div>
    );
}

export default Input;

// import { useContext } from "react";
// import { Context } from "../../context/UserContext";
// import styles from "./Input.module.css";

// function Input({
//     type,
//     text,
//     name,
//     placeholder,
//     handleOnChange,
//     handleOnBlur,
//     handleOnFocus,
//     value,
//     title,
//     required,
//     multiple,
//     inputWidth,
//     readonly,
//     disabled,
//     min,
//     max,
//     textAlign = "right",
//     handleOnInput,
// }) {
//     //configura o tema
//     const { parametro } = useContext(Context);

//     const validateInput = (e) => {
//         const value = e.target.value; // Obtém o valor atual do campo de entrada
//         // Substitui todos os caracteres não permitidos (tudo exceto 0-9, ponto e hífen) por uma string vazia
//         e.target.value = value.replace(/[^0-9.-]/g, "");
//         if (handleOnInput) {
//             handleOnInput(e); // Chama o manipulador de evento handleOnInput, se fornecido
//         }
//     };

//     return (
//         <div className={`${styles.form_control} ${styles[parametro.tema]}`}>
//             {type !== "hidden" && <label htmlFor={name}>{text}:</label>}

//             <input
//                 type="text"
//                 name={name}
//                 id={name}
//                 placeholder={placeholder}
//                 onChange={handleOnChange}
//                 onBlur={handleOnBlur}
//                 onFocus={handleOnFocus}
//                 value={value}
//                 title={title}
//                 required={required}
//                 style={{
//                     width: `var(--input-width, ${inputWidth})`,
//                     textAlign: textAlign,
//                 }}
//                 {...(multiple ? { multiple } : "")}
//                 readOnly={readonly === true ? true : false}
//                 disabled={disabled === true ? true : false}
//                 //pattern="[0-9.,]*"
//                 min={min}
//                 max={max}
//                 onInput={validateInput} // Adiciona validação de entrada
//                 inputMode="decimal" // ✅ abre teclado numérico no mobile
//             />
//         </div>
//     );
// }

// export default Input;
